/* eslint-disable no-console */
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, first, switchMap } from 'rxjs';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { Ente } from '@ideapa/app-shared-ente';
import { ENTE_ID_HEADER, ESERCIZIO_HEADER } from '@ideapa/common-utils';

import { AuthFacade } from './+state/auth.facade';

@Injectable()
export class EnteAnnoInterceptor implements HttpInterceptor {
  constructor(private authfacade: AuthFacade) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return combineLatest([this.authfacade.ente$, this.authfacade.anno$]).pipe(
      first(),
      switchMap(([ente, anno]) => {
        if (ente && anno) {
          request = this.addEnteAnnoHeader(request, ente, anno);
        } else if (anno) {
          request = this.addAnnoHeader(request, anno);
        }
        return next.handle(request);
      })
    );
  }

  private addEnteAnnoHeader(
    request: HttpRequest<unknown>,
    ente: Ente,
    anno: number
  ) {
    return request.clone({
      headers: request.headers
        .set(ENTE_ID_HEADER, ente.id.toString())
        .set(ESERCIZIO_HEADER, anno.toString()),
    });
  }

  private addAnnoHeader(request: HttpRequest<unknown>, anno: number) {
    return request.clone({
      headers: request.headers.set(ESERCIZIO_HEADER, anno.toString()),
    });
  }
}
